export const WorkData = [
  // {
  //   company: "Goldman Sachs",
  //   designation: "Summer Analyst",
  //   dateJoining: "May 2022",
  //   dateEnd: "present",
  //   companyLogo:
  //     "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Goldman_Sachs.svg/1200px-Goldman_Sachs.svg.png",
  //   work: "Yet to Join",
  // },
  // {
  //   company: "Meta",
  //   designation: "Software Developer",
  //   dateJoining: "May 2023",
  //   dateEnd: "present",
  //   companyLogo:
  //     "https://yt3.ggpht.com/AAnXC4o1n8BKDsO5l6Uc71rf7WOJjm2-aUHzkvyp9vGYB5F4UtXWTecVzvPOBCFK0bNYsZlD7Hk=s900-c-k-c0x00ffffff-no-rj",
  //   work: "Yet to Join",
  // },
  {
    company: "Geeks For Geeks",
    designation: "Technical Content Writer Intern",
    dateJoining: "Oct 2021",
    dateEnd: "Dec 2021",
    companyLogo: require("../../assets/gfg.png"),
    work: "Published many articles/problems on Competitive programming.",
  },
];
